import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import PermissionTabImageOne from 'assets/images/permission-tab-image-1.png';
import PermissionTabImageTwo from 'assets/images/permission-tab-image-2.png';
import PermissionTabImageThird from 'assets/images/permission-tab-image-3.png';
import PermissionCarouselOne from 'assets/images/permission-carousel-1.png';
import PermissionCarouselTwo from 'assets/images/permission-carousel-2.png';
import PermissionCarouselThree from 'assets/images/permission-carousel-3.png';
import AndroidPermissionCarouselOne from 'assets/images/android-permission-carousel-1.jpg';
import AndroidPermissionCarouselTwo from 'assets/images/android-permission-carousel-2.jpg';
import AndroidPermissionCarouselThree from 'assets/images/android-permission-carousel-3.jpg';

import Carousel, { CarouselItem } from "components/Carousel/Carousel";

import "./index.css";

const isUserAgentIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent)

const tabData = [
  {
    tabText: 'step1.tab',
    imgSrc: PermissionTabImageOne,
    carouselText: isUserAgentIOS()
      ? 'step1.carousel_ios'
      : 'step1.carousel_others',
    carouselImgSrc: isUserAgentIOS()
      ? PermissionCarouselOne
      : AndroidPermissionCarouselOne
  },
  {
    tabText: 'step2.tab',
    imgSrc: PermissionTabImageTwo,
    carouselText: isUserAgentIOS()
      ? 'step2.carousel_ios'
      : 'step2.carousel_others',
    carouselImgSrc: isUserAgentIOS()
      ? PermissionCarouselTwo
      : AndroidPermissionCarouselTwo
  },
  {
    tabText: 'step3.tab',
    imgSrc: PermissionTabImageThird,
    carouselText: isUserAgentIOS()
      ? 'step3.carousel_ios'
      : 'step3.carousel_others',
    carouselImgSrc: isUserAgentIOS()
      ? PermissionCarouselThree
      : AndroidPermissionCarouselThree
  }
];

const CarouselComponent = () => {
  const { t } = useTranslation()
  return (
    <Carousel>
      {
        tabData.map((tab, index) => {
          return (
            <CarouselItem>
              <div className={`tab flex flex-col items-center justify-center`}>
                <div className="tab-description flex items-center justify-center mb-4">
                  <div className="tab-number-carousel">
                    <span>{index + 1}</span>
                  </div>
                  <p className="tab-text-carousel">{t(`permissions.micTab.${tab.carouselText}`)}</p>
                </div>
                <div className="tab-image-carousel flex items-center justify-center mb-4">
                  <img src={tab.carouselImgSrc} alt="permission-access-microphone" />
                </div>
              </div>
            </CarouselItem>
          )
        })
      }
    </Carousel>
  );
};

const PermissionTabComponent = ({ tabText, tabNumber, imgSrc }) => {

  return (
    <div className={`tab w-1/3 px-5
      flex flex-col items-center justify-start 
        ${tabNumber === 2 ? 'px-8 mx-5 border border-solid border-y-0 border-[rgba(218,218,218,0.1)]' : ''}
      `}>
      <div className="tab-description flex items-center justify-center mb-4">
        <div className="tab-number px-[12px] py-[3px] mr-2 rounded-full bg-[rgba(255,255,255,0.2)]">
          <span className="relative bottom-[1px] text-white text-base">{tabNumber}</span>
        </div>
        <p className="tab-text text-white text-base">{tabText}</p>
      </div>
      <div className="tab-image flex justify-center">
        <img src={imgSrc} className="w-[70%]" alt="permission-access-microphone-1" />
      </div>
    </div>
  );
};

export const PermissionsModal = ({ openPopup }) => {
  const { t } = useTranslation()

  const overlayModalClass = classNames(
    "relative flex flex-col justify-center z-[50]",
    "h-fit w-fit px-4 py-6 rounded-[20px] mt-8",
    "text-center tracking-[-0.15px] text-base sm:text-lg font-normal",
    "sm:relative sm:w-fit sm:p-8 sm:h-fit sm:rounded-[20px] sm:mt-0 bg-[#292929] text-[#292929]"
  );

  return (
    <>
      {
        openPopup &&
        <div
          className={classNames(`fixed left-0 top-0 w-full h-full 
            sm:flex sm:items-center sm:justify-center z-[40] backdrop-blur-sm`
          )}
        >
          <div className="fixed left-0 top-0 min-w-full min-h-full bg-[rgba(39,39,39,0.9)] z-[40]"></div>
          <div className={overlayModalClass}>
            <div className="permission-modal-body flex flex-col items-center justify-center">
              <div className="description break-words text-center flex flex-col items-center justify-center mb-4 sm:mb-12">
                <h1 className="text-2xl sm:text-5xl px-4 text-white mb-3">{t("permissions.micTab.title")}</h1>
                <p className="opacity-50 px-4 text-white text-base">
                  {t("permissions.micTab.subtext")}
                </p>
              </div>
              <div className="hidden permission-tabs sm:flex items-start justify-center">
                {
                  tabData.map((tab, index) => {
                    return (
                      <PermissionTabComponent
                        tabText={t(`permissions.micTab.${tab.tabText}`)}
                        tabNumber={index + 1}
                        imgSrc={tab.imgSrc}
                      />
                    )
                  })
                }
              </div>
              <div className="sm:hidden">
                <CarouselComponent />
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};